import { Observable } from 'rxjs';
import { PlemsiToken } from './model';

export abstract class PlemsiTokenRepository {
  abstract getPlemsiToken(users_id: number): Observable<PlemsiToken>;
  abstract updatePlemsiToken(users_id: number, token: string): Observable<PlemsiToken>;
  abstract deletePlemsiToken(users_id: number): Observable<void>;
}
